import UploadPicture from "./UploadPicture";
export default UploadPicture;
